export const QA_NAME_REMOVE_BUILDING_GROUP_MODAL = 'removeGroup'

export const BUILDING_GROUP_ACTION_REMOVE_GROUP_FIELD_NAME_REMOVE_MANAGERS =
  'perform_for_buildings'

export const BUILDING_GROUP_ACTION_REMOVE_GROUP_INITIAL_VALUES = {
  [BUILDING_GROUP_ACTION_REMOVE_GROUP_FIELD_NAME_REMOVE_MANAGERS]: false,
}
